import React, { useState, useEffect } from "react";
import "./EmojiQuiz.css";

const easyQuiz = [
  { emojis: "🍎📱", answer: "Apple" },
  { emojis: "⚽️🏆", answer: "Football" },
  { emojis: "🚗💨", answer: "Car" },
  { emojis: "🎸🎶", answer: "Guitar" },
  { emojis: "🐶🐾", answer: "Dog" },
  { emojis: "🐱😺", answer: "Cat" },
  { emojis: "🍌🙈", answer: "Banana" },
  { emojis: "🌞🌻", answer: "Sun" },
  { emojis: "🌧️☔️", answer: "Rain" },
  { emojis: "🌙⭐️", answer: "Moon" },
  { emojis: "🍕🥤", answer: "Pizza" },
  { emojis: "🍫🍬", answer: "Chocolate" },
  { emojis: "🎂🎉", answer: "Cake" },
  { emojis: "🚌🚏", answer: "Bus" },
  { emojis: "✈️🌍", answer: "Airplane" },
  { emojis: "🚲👟", answer: "Bicycle" },
  { emojis: "🚂🚉", answer: "Train" },
  { emojis: "🏠🔑", answer: "House" },
  { emojis: "🏫📚", answer: "School" },
  { emojis: "🛏️😴", answer: "Bed" },
  { emojis: "🖊️📄", answer: "Pen" },
  { emojis: "📱📞", answer: "Phone" },
  { emojis: "💡🔌", answer: "Light" },
  { emojis: "🖥️⌨️", answer: "Computer" },
  { emojis: "🎤🎵", answer: "Microphone" },
  { emojis: "📺📡", answer: "Television" },
  { emojis: "🎮👾", answer: "Game" },
  { emojis: "🧸👶", answer: "Toy" },
  { emojis: "🧃🥪", answer: "Lunch" },
  { emojis: "🍳🥚", answer: "Egg" },
  { emojis: "🥛🍪", answer: "Milk" },
  { emojis: "🍇🍷", answer: "Grapes" },
  { emojis: "🍓🍰", answer: "Strawberry" },
  { emojis: "🍍🥤", answer: "Pineapple" },
  { emojis: "🥕🐇", answer: "Carrot" },
  { emojis: "🌲🎄", answer: "Tree" },
  { emojis: "🌊🏖️", answer: "Sea" },
  { emojis: "🏀⛹️", answer: "Basketball" },
  { emojis: "🎯🏹", answer: "Target" },
  { emojis: "🎁🎀", answer: "Gift" }
];

const hardQuiz = [
  { emojis: "🌍🚀", answer: "Planet" },
  { emojis: "📚✏️", answer: "Book" },
  { emojis: "🍔🍟🥤", answer: "Fastfood" },
  { emojis: "🎬🍿", answer: "Movie" },
  { emojis: "💻🌐", answer: "Internet" },
  { emojis: "🧪🔬", answer: "Science" },
  { emojis: "🎨🖌️", answer: "Painting" },
  { emojis: "🎼🎻", answer: "Music" },
  { emojis: "🏛️⚖️", answer: "Law" },
  { emojis: "🧭🌏", answer: "Geography" },
  { emojis: "🧮📊", answer: "Math" },
  { emojis: "🧠💭", answer: "Mind" },
  { emojis: "🕰️⌛️", answer: "Time" },
  { emojis: "🔭🌌", answer: "Astronomy" },
  { emojis: "🧬🧫", answer: "Biology" },
  { emojis: "⚗️🔥", answer: "Chemistry" },
  { emojis: "🏹⚔️", answer: "War" },
  { emojis: "📖✍️", answer: "Story" },
  { emojis: "🗺️🧳", answer: "Travel" },
  { emojis: "🏗️🛠️", answer: "Construction" },
  { emojis: "🧑‍🍳🍲", answer: "Cooking" },
  { emojis: "🧑‍⚕️💊", answer: "Doctor" },
  { emojis: "🧑‍🏫📖", answer: "Teacher" },
  { emojis: "🧑‍🚀🌌", answer: "Astronaut" },
  { emojis: "🧑‍🎤🎶", answer: "Singer" },
  { emojis: "🧑‍🎓🎓", answer: "Student" },
  { emojis: "🧑‍💻💾", answer: "Programmer" },
  { emojis: "🧑‍🔬🧪", answer: "Scientist" },
  { emojis: "🧑‍🎨🎨", answer: "Artist" },
  { emojis: "🧑‍⚖️⚖️", answer: "Judge" },
  { emojis: "🧑‍✈️✈️", answer: "Pilot" },
  { emojis: "🧑‍🚒🔥", answer: "Firefighter" },
  { emojis: "🧑‍🚓🚨", answer: "Police" },
  { emojis: "🧑‍🌾🌱", answer: "Farmer" },
  { emojis: "🧑‍🔧🔩", answer: "Mechanic" },
  { emojis: "🧑‍🎮🎮", answer: "Gamer" },
  { emojis: "🧑‍⚕️🩺", answer: "Nurse" },
  { emojis: "🧑‍⚖️📜", answer: "Lawyer" },
  { emojis: "🧑‍🏭🏭", answer: "Worker" },
  { emojis: "🧑‍🚀🚀", answer: "Space" }
];

export default function EmojiQuiz() {
  const [difficulty, setDifficulty] = useState("easy");
  const [questionIndex, setQuestionIndex] = useState(0);
  const [answer, setAnswer] = useState("");
  const [score, setScore] = useState(0);
  const [message, setMessage] = useState("");
  const [time, setTime] = useState(0);
  const [gameOver, setGameOver] = useState(false);

  // Load sounds
  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  const quizData = difficulty === "easy" ? easyQuiz : hardQuiz;

  useEffect(() => {
    setQuestionIndex(0);
    setScore(0);
    setTime(0);
    setGameOver(false);
    setMessage("");
  }, [difficulty]);

  useEffect(() => {
    let timer;
    if (!gameOver) {
      timer = setInterval(() => setTime((t) => t + 1), 1000);
    }
    return () => clearInterval(timer);
  }, [gameOver]);

  const checkAnswer = () => {
    const current = quizData[questionIndex];
    if (answer.trim().toLowerCase() === current.answer.toLowerCase()) {
      setScore(score + 10);
      setMessage("✅ Correct!");
      correctSound.play();
      if (questionIndex + 1 < quizData.length) {
        setQuestionIndex(questionIndex + 1);
      } else {
        setMessage("🎉 You win! Final Score: " + (score + 10));
        setGameOver(true);
        winSound.play();
      }
    } else {
      setScore(score - 5);
      setMessage("❌ Wrong, try again!");
      wrongSound.play();
    }
    setAnswer("");
  };

  return (
    <div className="quiz-container">
      <h1>🤔 Emoji Quiz Game</h1>
      <div className="mode-buttons">
        <button onClick={() => setDifficulty("easy")}>Easy</button>
        <button onClick={() => setDifficulty("hard")}>Hard</button>
      </div>
      <div className="stats">
        <p>⏱ Time: {time}s</p>
        <p>⭐ Score: {score}</p>
      </div>
      {!gameOver ? (
        <div className="quiz-card">
          <p className="question">{quizData[questionIndex].emojis}</p>
          <input
            type="text"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            className="answer-input"
            placeholder="Your answer..."
          />
          <button onClick={checkAnswer}>Submit</button>
        </div>
      ) : (
        <h2>{message}</h2>
      )}
      <p className="status">{message}</p>
    </div>
  );
}










